import type { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/base/form/hook-form";
import { Select, type SelectProps } from "../select/select";

export type FormSelectFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = {
  field: ControllerRenderProps<TFieldValues, Path<TFieldValues>>;
  label?: string;
  labelClasses?: string;
  selectClasses?: string;
  description?: string;
  className?: string;
} & SelectProps;

export const FormSelectField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  label,
  labelClasses,
  description,
  isRequired,
  field,
  className,
  selectClasses,
  ...props
}: FormSelectFieldProps<TFieldValues>) => {
  return (
    <FormItem className={className}>
      <FormLabel className={labelClasses} required={isRequired}>
        {label}
      </FormLabel>
      <FormControl>
        <Select
          {...props}
          {...field}
          aria-label={label}
          selectedKey={field.value}
          onSelectionChange={field.onChange}
          className={selectClasses}
          isRequired={isRequired}
        />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  );
};

FormSelectField.displayName = "FormSelectField";
